/**
 * Timeline UI management for chart display
 */
import { colorToHex } from '../utils/colors.js';

/**
 * Add DJ legend to the UI
 * @param {Array} djs - Array of DJ data
 */
export function addDJLegend(djs) {
  const usersDiv = document.querySelector('#usersDiv');

  // Remove existing DJ legend if present
  const existingLegend = document.querySelector('#djLegendDiv');
  if (existingLegend) {
    existingLegend.remove();
  }

  const djLegendDiv = document.createElement('div');
  djLegendDiv.setAttribute('id', 'djLegendDiv');
  djLegendDiv.classList.add('djLegendDiv');

  djs.forEach((dj) => {
    const djNameDiv = document.createElement('span');
    djNameDiv.classList.add('djNameDiv');
    djNameDiv.setAttribute('style', `color: ${colorToHex(dj.color)};`);
    if (dj.url) {
      const dja = document.createElement('a');
      dja.setAttribute('target', '_blank'); // Open dj.url in new tab.
      dja.setAttribute('href', dj.url);
      dja.setAttribute('style', `color: ${colorToHex(dj.color)};`);
      dja.textContent = dj.realname || dj.name;
      djNameDiv.append(dja);
    } else {
      djNameDiv.textContent = dj.realname || dj.name;
    }
    djLegendDiv.append(djNameDiv);
  });

  // Insert at the beginning of usersDiv (before newUserDiv)
  const firstChild = usersDiv.firstChild;
  if (firstChild) {
    usersDiv.insertBefore(djLegendDiv, firstChild);
  } else {
    usersDiv.append(djLegendDiv);
  }
}

/**
 * Add a user div to the UI
 * @param {Object} user - User data
 * @param {Function} removeCallback - Callback when user is removed
 */
export function addUserDiv(user, removeCallback) {
  const usersDiv = document.querySelector('#usersDiv');
  const userDiv = document.createElement('div');
  userDiv.setAttribute('id', `user${user.name}Div`);
  userDiv.classList.add('userDiv');

  const userIdDiv = document.createElement('div');
  userIdDiv.classList.add('userIdDiv');
  userIdDiv.setAttribute('style', `color: ${colorToHex(user.color)};`);
  userIdDiv.textContent = user.name;

  const userRemoveButton = document.createElement('input');
  userRemoveButton.setAttribute('type', 'button');
  userRemoveButton.setAttribute('value', 'ⓧ');
  userRemoveButton.addEventListener('click', () => removeCallback(user.id));

  const userChartDiv = document.createElement('div');
  userChartDiv.classList.add('chartDivContainer');
  addChartDivs(user, userChartDiv);

  userDiv.append(userIdDiv, userRemoveButton, userChartDiv);
  usersDiv.append(userDiv);
}

/**
 * Add chart divs for a user's timeline
 * @param {Object} user - User data
 * @param {HTMLElement} userChartDiv - Container element
 */
export function addChartDivs(user, userChartDiv) {
  const startDate = new Date();
  startDate.setFullYear(startDate.getFullYear() - 1);

  const charts = user.charts.filter((c) => c.date >= startDate);
  const w = window.innerWidth;
  const cw = w - 250; // width minus userid label
  const ciw = cw / charts.length;

  charts.forEach((c) => {
    const chartDiv = document.createElement('div');
    chartDiv.setAttribute('style', `inline-size: ${ciw}px;`);
    chartDiv.classList.add('chartDiv');
    chartDiv.setAttribute('id', `chartId${c.id}`);
    userChartDiv.append(chartDiv);
  });
}

/**
 * Highlight active chart in timeline
 * @param {Object} chart - Chart data
 */
export function highlightChartDiv(chart) {
  const chartDivs = document.querySelectorAll('.chartDiv');
  for (let i = 0, l = chartDivs.length; i < l; i += 1) {
    chartDivs[i].classList.remove('chartDivActive');
    chartDivs[i].textContent = '';
  }

  const cd = document.querySelector(`#chartId${chart.id}`);
  if (cd) {
    cd.classList.add('chartDivActive');
    if (chart.playcount < 5) {
      cd.classList.add('chartDivNoPlays');
    } else {
      cd.classList.add('chartDivGotData');
    }
    cd.textContent = chart.date.toLocaleDateString();
  }
}

/**
 * Remove user div from UI
 * @param {string} userName - Username
 */
export function removeUserDiv(userName) {
  const userDiv = document.querySelector(`#user${userName}Div`);
  if (userDiv) {
    userDiv.remove();
  }
}
